import { Button } from "@sikt/sds-button";
import { ConfirmIcon, CopyIcon } from "@sikt/sds-icons";
import { TextInput } from "@sikt/sds-input";
import { useEffect, useRef, useState } from "react";
import styles from "./CopyField.module.css";

export function CopyField({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Eldre nettlesere/usikker kontekst: brukeren kan markere og kopiere selv.
    }
  };

  return (
    <div className={styles.row}>
      <TextInput
        className={styles.input}
        label={label}
        value={value}
        readOnly
        onFocus={(event) => event.currentTarget.select()}
      />
      <Button
        type="button"
        icon={copied ? <ConfirmIcon /> : <CopyIcon />}
        iconVariant="left"
        onClick={copy}
      >
        {copied ? "Kopiert!" : "Kopier"}
      </Button>
    </div>
  );
}
